import { FC, useEffect, useState } from "react";
import {
    DefectType,
    PriorityType,
    WarrantyItemForDamaged,
} from "../../../types";
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import {
    DialogDefectContainer,
    StyledInputBox,
    StyledInputBoxRadio,
} from "./DamagedAndBrokenParts.style";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { AppIconsArrow, AppIconsClose } from "../../AppIcons";
import AppIconsArrow1 from "../../AppIcons/AppIconsArrow1";

type TDamagedAndBrokenPartsDefect = {
    item: WarrantyItemForDamaged;
    errorList: { key: string; indexes: string[] }[];
};

const DamagedAndBrokenPartsDefect: FC<TDamagedAndBrokenPartsDefect> = (
    props
) => {
    const { item, errorList } = props;
    const { t } = useTranslation();

    const [defect, setDefect] = useState<DefectType | undefined>(
        item.damageType
    );
    const [priority, setPriority] = useState<PriorityType>(
        item.priority ?? PriorityType.Medium
    );
    const [radioValue, setRadioValue] = useState<boolean>(
        item.scrappedMaterialOnSite ?? true
    );

    const handleChangeDefect = (event: SelectChangeEvent) => {
        setDefect(event.target.value as DefectType);
    };

    const handleChangePriority = (event: SelectChangeEvent) => {
        setPriority(event.target.value as PriorityType);
    };

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRadioValue(event.target.value === "yes");
    };

    useEffect(() => {
        item.damageType = defect;
    }, [defect]);

    useEffect(() => {
        item.priority = priority;
    }, [priority]);

    useEffect(() => {
        item.scrappedMaterialOnSite = radioValue;
    }, [radioValue]);

    return (
        <DialogDefectContainer>
            <StyledInputBox>
                <InputLabel id="select-defect">
                    {t("warranty.defect")}
                </InputLabel>
                <FormControl
                    sx={{
                        display: "flex",
                        width: 400,
                    }}
                    required
                   variant="standard"
                   
                  
                >
                    <Select
                        id="defect"
                        value={defect ?? ""}
                        onChange={handleChangeDefect}
                        error={errorList.some(
                            (x) =>
                                x.key.includes("damageType") &&
                                x.indexes.includes(item.rowId)
                        )}
                       
                        IconComponent={AppIconsArrow}
                    
                        
                    >
                        <MenuItem value={DefectType.BrokenDuringTransport}>
                            {t(`warranty.${DefectType.BrokenDuringTransport}`)}
                        </MenuItem>
                        <MenuItem value={DefectType.OnFirstStartUp}>
                            {t(`warranty.${DefectType.OnFirstStartUp}`)}
                        </MenuItem>
                        <MenuItem value={DefectType.DuringStartUpFirstWeek}>
                            {t(`warranty.${DefectType.DuringStartUpFirstWeek}`)}
                        </MenuItem>
                        <MenuItem value={DefectType.DefectiveUnderWarranty}>
                            {t(`warranty.${DefectType.DefectiveUnderWarranty}`)}
                        </MenuItem>
                    </Select>
                </FormControl>
            </StyledInputBox>
            <StyledInputBoxRadio>
                <FormControl>
                    <FormLabel id="scrappedMaterialSite_label">
                        {t("warranty.scrappedMaterialSite")}
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="scrappedMaterialSite_label"
                        name="scrappedMaterialSite_group"
                        onChange={handleRadioChange}
                        defaultValue={
                            item.scrappedMaterialOnSite !== undefined
                                ? item.scrappedMaterialOnSite === true
                                    ? "yes"
                                    : "no"
                                : "yes"
                        }
                    >
                        <FormControlLabel
                            value={"yes"}
                            control={<Radio />}
                            label={t("common.yes")}
                        />
                        <FormControlLabel
                            value={"no"}
                            control={<Radio />}
                            label={t("common.no")}
                        />
                    </RadioGroup>
                </FormControl>
            </StyledInputBoxRadio>
            <StyledInputBox>
                <InputLabel id="select-priority">
                    {t("warranty.priority")}
                </InputLabel>
                <FormControl
                    sx={{
                        display: "flex",
                        width: 150,
                    }}
                    required
                    variant="standard"
                >
                    <Select
                        id="priority"
                        value={priority}
                        onChange={handleChangePriority}
                        defaultValue={PriorityType.Medium}
                        IconComponent={AppIconsArrow}
                    >
                        <MenuItem value={PriorityType.High}>
                            {t(`warranty.${PriorityType.High}`)}
                        </MenuItem>
                        <MenuItem value={PriorityType.Medium}>
                            {t(`warranty.${PriorityType.Medium}`)}
                        </MenuItem>
                        <MenuItem value={PriorityType.Low}>
                            {t(`warranty.${PriorityType.Low}`)}
                        </MenuItem>
                    </Select>
                </FormControl>
            </StyledInputBox>
        </DialogDefectContainer>
    );
};

export default DamagedAndBrokenPartsDefect;
